import { RecognitionStatus } from '../types';

export type RecognitionError = 'SWAP_LIMIT_EXCEEDED';
export const SWAP_LIMIT_EXCEEDED: RecognitionError = 'SWAP_LIMIT_EXCEEDED';

export type ContractLineStatuses = {
  label: RecognitionStatus;
  value: RecognitionStatus;
};

export enum AddRecognitionError {
  blockCommercialVehicle = 'commercialVehicle',
}

export const contractLineStatuses: ContractLineStatuses[] = [
  { label: 'blocked', value: 'blocked' },
  { label: 'pending', value: 'pending' },
  { label: 'open', value: 'open' },
  { label: 'closed', value: 'closed' },
];

// Least allowed vehicle weight in KG for a KM-toll vehicle
export const minTollingVehicleWeight = 12000;

// Provided id from BC
export const kmTollActorId = 978005;
